import {
  Text,
  IconTrashCan,
  IconPlus,
  Button,
  GreyGrey60,
  Primary13SemiBold,
  RedRed50,
  TextFieldInput,
  Flex
} from '@sequencehq/core-components'

export const CustomerAliasField = (props: {
  aliases: string[]
  onChange: (updatedAliases: string[]) => void
  lockedAliasCount?: number
  'data-testid'?: string
}) => {
  const lockedCount = props.lockedAliasCount ?? 0

  return (
    <Flex flexDirection={'column'} gap="8px">
      <Text {...Primary13SemiBold} color={GreyGrey60}>
        Customer aliases
      </Text>
      {props.aliases.map((alias, idx) => {
        const isLocked = idx < lockedCount
        return (
          <Flex alignItems="center" gap="8px" key={idx}>
            <TextFieldInput
              data-testid={
                props['data-testid']
                  ? `${props['data-testid']}.alias.${idx}`
                  : undefined
              }
              value={alias}
              isDisabled={isLocked}
              onChange={e => {
                const updatedAliases = [...props.aliases]
                updatedAliases[idx] = e.target.value
                props.onChange(updatedAliases)
              }}
              placeholder="Customer alias (optional)"
              style={{
                paddingLeft: '12px'
              }}
            />
            {(props.aliases.length > 1 || props.aliases[0] !== '') && (
              <Button
                variant="ghost"
                size="24px"
                aria-label="Remove alias"
                icon={<IconTrashCan />}
                color={GreyGrey60}
                hover={isLocked ? undefined : { color: RedRed50 }}
                style={{ flexShrink: 0 }}
                disabled={isLocked}
                data-testid={
                  props['data-testid']
                    ? `${props['data-testid']}.alias.${idx}.delete`
                    : undefined
                }
                onClick={() => {
                  const updatedAliases = props.aliases.filter(
                    (_, i) => i !== idx
                  )
                  props.onChange(
                    updatedAliases.length === 0 ? [''] : updatedAliases
                  )
                }}
              />
            )}
          </Flex>
        )
      })}
      <Button
        variant="ghost"
        fullWidth
        leadingIcon={<IconPlus />}
        data-testid={
          props['data-testid'] ? `${props['data-testid']}.addAlias` : undefined
        }
        onClick={() => {
          props.onChange([...props.aliases, ''])
        }}
      >
        Add alias
      </Button>
    </Flex>
  )
}
